import * as api from '../api'
import state from './state';

const actions = {

    //#region [ AUTH CMS ]
    //////////////////////////[ AUTH ]//////////////////////////
    LOGIN({ commit }, { user_id, password }) {
        return api.auth.login(user_id, password)
            .then(({ session_id, user_id, user_level }) => commit('LOGIN', { session_id, user_id, user_level }))
    },
    SIGN_IN(_, { user_id, password }) {
        return api.auth.sign_in(user_id, password);
    },

    //////////////////////////[ GAMES ]//////////////////////////
    GET_GAMES({ state }) {
        return api.games.get_games(state.user_id);
    },

    //////////////////////////[ 스냅퀴즈 서버 설정 ]//////////////////////////
    SNAPQUIZ_GIT_PATCH({ state }) {
        return api.snapquiz_setting.git_patch(state.user_id);
    },
    SNAPQUIZ_CHECK_SERVER({ state }) {
        return api.snapquiz_setting.check_server(state.user_id);
    },

    //////////////////////////[ GAMES ]//////////////////////////
    GET_SERVERS({ state }, { package_name }) {
        return api.servers.get_servers(package_name);
    },



    //////////////////////////[ AD ]//////////////////////////
    GET_APP_INFO_LIST({ state }, { selected_ad_os, selected_ad_language }) {
        return api.ad.get_app_info_list(state.user_id, selected_ad_os, selected_ad_language);
    },

    GET_STATISTICS_DATA({ state }, { selected_ad_os, selected_ad_language, app_ad, tempInfo }) {
        return api.ad.get_statistics_data(state.user_id, selected_ad_os, selected_ad_language, app_ad, tempInfo);
    },

    APP_ORDERING({ state }, { selected_ad_os, selected_ad_language, list_for_ordering }) {
        return api.ad.app_ordering(state.user_id, selected_ad_os, selected_ad_language, list_for_ordering);
    },

    UPDATE_USE_FLAG({ state }, { selected_ad_os, selected_ad_language, selected_app_id, app_use_flag }) {
        return api.ad.update_use_flag(state.user_id, selected_ad_os, selected_ad_language, selected_app_id, app_use_flag);
    },

    // 광고 설정을 하는 요청
    UPDATE_AD_CONFIG({ state }, {
        selected_ad_os,
        selected_ad_language,
        app_id,
        app_front_ad_flag,
        app_main_ad_flag,
        app_mid_ad_flag,
        app_end_ad_flag,
        app_first_order,
        app_repeat_count,
    }) {
        return api.ad.update_ad_config(
            state.user_id,
            selected_ad_os,
            selected_ad_language,
            app_id,
            app_front_ad_flag,
            app_main_ad_flag,
            app_mid_ad_flag,
            app_end_ad_flag,
            app_first_order,
            app_repeat_count,
        );
    },

    // 수정하려는 appId의 info를 가져온다.
    GET_APP_INFO({ state }, { selected_ad_os, selected_ad_language, appId }) {
        return api.ad.get_app_info(state.user_id, selected_ad_os, selected_ad_language, appId);
    },

    // 파일을 s3에서 업로드 또는 삭제 하며, 데이터베이스에도 반영한다.
    UPLOAD_DELETE_FILE({ state }, { selected_ad_os, selected_ad_language, appId, fileType, uploadOrDelete, file, fileId }) {
        return api.ad.upload_delete_file(state.user_id, selected_ad_os, selected_ad_language, appId, fileType, uploadOrDelete, file, fileId);
    },

    //////////////////////////[ HOUSE AD ]//////////////////////////
    HOUSEAD_FETCH_CMS_INIT({ commit }) {
        return api.housead.cmsInit()
            .then((data) => {
                const apps = (data && data.apps) || [];
                const rewardTypes = (data && data.rewardTypes) || [];
                let adConfigs = (data && data.adConfigs) || [];
                let adConfigOrder = (data && data.adConfigOrder) || [];
                if (adConfigs && !Array.isArray(adConfigs) && adConfigs.list) {
                    adConfigOrder = adConfigs.order || adConfigOrder;
                    adConfigs = adConfigs.list;
                }
                if (!adConfigOrder.length && Array.isArray(adConfigs)) adConfigOrder = adConfigs.map(c => c.appId);
                commit('SET_HOUSEAD_APP_LIST', apps);
                commit('SET_HOUSEAD_REWARD_TYPES', rewardTypes);
                commit('SET_HOUSEAD_AD_CONFIGS', adConfigs);
                commit('SET_HOUSEAD_AD_CONFIG_ORDER', adConfigOrder);
                return data;
            });
    },
    HOUSEAD_CREATE_APP({ commit }, { item }) {
        return api.housead.createApp(item).then((created) => {
            const saved = created && typeof created === 'object' ? { ...item, id: created.id != null ? String(created.id) : item.id, ...created } : item;
            commit('SET_HOUSEAD_APP_ITEM', { index: -1, item: saved });
            return saved;
        });
    },
    HOUSEAD_UPDATE_APP({ commit }, { index, item }) {
        return api.housead.updateApp(item.id, item).then((updated) => {
            const saved = updated && typeof updated === 'object' ? { ...item, ...updated } : item;
            commit('SET_HOUSEAD_APP_ITEM', { index, item: saved });
            return saved;
        });
    },
    HOUSEAD_DELETE_APP({ commit, state }, { index }) {
        const list = state.housead_app_list || [];
        const item = list[index];
        if (!item || item.id == null) return Promise.reject(new Error('앱 정보 없음'));
        return api.housead.deleteApp(item.id).then(() => {
            commit('REMOVE_HOUSEAD_APP', index);
        });
    },
    HOUSEAD_CREATE_REWARD_TYPE({ commit }, { item }) {
        return api.housead.createRewardType(item).then((created) => {
            const saved = created && typeof created === 'object' ? { ...item, id: created.id != null ? String(created.id) : item.id, ...created } : item;
            commit('SET_HOUSEAD_REWARD_TYPE_ITEM', { index: -1, item: saved });
            return saved;
        });
    },
    HOUSEAD_UPDATE_REWARD_TYPE({ commit }, { index, item }) {
        return api.housead.updateRewardType(item.id, item).then((updated) => {
            const saved = updated && typeof updated === 'object' ? { ...item, ...updated } : item;
            commit('SET_HOUSEAD_REWARD_TYPE_ITEM', { index, item: saved });
            return saved;
        });
    },
    HOUSEAD_DELETE_REWARD_TYPE({ commit, state }, { index }) {
        const list = state.housead_reward_types || [];
        const item = list[index];
        if (!item || item.id == null) return Promise.reject(new Error('보상 타입 없음'));
        return api.housead.deleteRewardType(item.id).then(() => {
            commit('REMOVE_HOUSEAD_REWARD_TYPE', index);
        });
    },
    HOUSEAD_PUT_AD_CONFIGS({ commit, state }) {
        const configs = state.housead_ad_configs || [];
        const order = state.housead_ad_config_order || [];
        return api.housead.putAdConfigs({ configs, order }).then(() => {
            // 서버 반영 완료, 스토어는 이미 최신 상태
        });
    },
    HOUSEAD_GET_PARTICIPATION_LIST() {
        return api.housead.getParticipationList();
    },
    HOUSEAD_SEARCH_PARTICIPATION({ state }, { search_type, keyword }) {
        return api.housead.searchParticipation(search_type, keyword);
    },
    HOUSEAD_DELETE_PARTICIPATION({ state }, { pid }) {
        return api.housead.deleteParticipation(pid);
    },

    //////////////////////////[ CMS ]//////////////////////////
    GET_CMS_USER_LIST({ state }) {
        return api.cms_managed.get_cms_user_list(state.user_id);
    },
    UPDATE_CMS_USER_LEVEL({ state }, { target_id, level }) {
        return api.cms_managed.update_cms_user_level(state.user_id, target_id, level);
    },
    DELETE_CMS_USER({ state }, { target_id }) {
        return api.cms_managed.delete_cms_user(state.user_id, target_id);
    },
    //////////////////////////[ USER INFO ]//////////////////////////

    GET_DASHBOARD_DATA({ state }) {
        return api.dash_board.get_dashboard_data();
    },
    CPU_GET_DAILY_SALES_STATISTICS({ state }) {
        return api.dash_board.get_daily_sales_statistics(state.user_id);
    },
    GET_DASHBOARD_HEALTH_DATA({ state }) {
        return api.dash_board.get_dashboard_health_data();
    },

    INSERT_UTIL_IMG_S3({ state }, { thumb_path }) {
        return api.util_img.insert_util_img_s3(thumb_path);
    },
    GET_UTIL_IMG_S3_LIST({ state }, { count }) {
        return api.util_img.get_util_img_s3_list(count);
    },


    //////////////////////////[ 에러로그 조회 ]//////////////////////////
    //errorlog_list
    //GET_GAME_SETTING({state}, {packageName})
    GET_ERROR_LOG_RECENT({ state }, { packageName }) {
        console.log("GET_ERROR_LOG_RECENT   packageName : " + packageName);
        return api.errorlog_list.get_recent_error_logs(state.user_id, packageName);
    },

    //#endregion

    //*************[ 포인트 채굴기 ]  */
    //#region [ 포인트 채굴기 ]

    // [API 테스터] 특정 유저에게 푸시 발송
    CPU_SEND_PUSH_BY_USERID({ state }, { user_id, title, message }) {
        return api.cpu_dev.send_push_by_userid(state.user_id, user_id, title, message);
    },
    // [API 테스터] 오퍼월 테스트 지급 (base_domain: 라이브/개발 선택 도메인)
    CPU_OFFERWALL_TEST({ state }, { provider, user_id, user_pnt, adv_id, base_domain }) {
        return api.cpu_dev.offerwall_test(state.user_id, provider, user_id, user_pnt, adv_id, base_domain);
    },
    // [API 테스터] 최근 수집된 adv_id 목록
    CPU_GET_RECENT_ADV_IDS({ state }) {
        return api.cpu_dev.get_recent_adv_ids(state.user_id);
    },

    BAN_USER({ state }, { packageName, target_user, exp, exp_info, server_index }) {
        return api.cpu_user_info.ban_user(state.user_id, packageName, target_user, exp, exp_info, server_index);
    },
    UNBAN_USER({ state }, { target_user }) {
        return api.cpu_user_info.unban_user(state.user_id, target_user);
    },

    GET_USERLIST_RECENT({ state }, { count }) {
        return api.cpu_user_info.get_userlist_recent(state.user_id, count);
    },
    GET_USERLIST_REFEREE({ state }, { count }) {
        return api.cpu_user_info.get_userlist_referee(state.user_id, count);
    },
    GET_USERLIST_ENJOY_AD({ state }, { count, type }) {
        return api.cpu_user_info.get_userlist_enjoy_ad(state.user_id, count, type);
    },
    GET_USERLIST_HAVE_COIN({ state }, { count, type }) {
        return api.cpu_user_info.get_userlist_have_coin(state.user_id, count, type);
    },

    CHANGE_USER_NICK_NAME({ state }, { user_id, nick }) {
        return api.cpu_user_info.change_user_nick_name(state.user_id, user_id, nick);
    },
    SET_USER_PHONE_NUMBER({ state }, { user_id, phone }) {
        return api.cpu_user_info.set_user_phone_number(state.user_id, user_id, phone);
    },
    RESET_USER_PHONE({ state }, { user_id }) {
        return api.cpu_user_info.reset_user_phone(state.user_id, user_id);
    },

    GET_USER_REFEREE_LIST({ state }, { user_id }) {
        return api.cpu_user_info.get_user_referee_list(state.user_id, user_id);
    },
    GET_USER_CPU_LIST({ state }, { user_id }) {
        return api.cpu_user_info.get_user_cpu_list(state.user_id, user_id);
    },
    GET_USER_PLANET_LIST({ state }, { user_id }) {
        return api.cpu_user_info.get_user_planet_list(state.user_id, user_id);
    },
    GET_USER_CASHLOG_LIST({ state }, { user_id }) {
        return api.cpu_user_info.get_user_cashlog_list(state.user_id, user_id);
    },

    //
    CPU_GET_USER_BUY_PRODUCTS({ state }) {
        return api.cpu_user_buy_products.get_user_buy_products();
    },
    REFUND_USER_CPU({ state }, { user_id, bonus_log_pid, refund_cash }) {
        return api.cpu_user_info.refund_user_cpu(state.user_id, user_id, bonus_log_pid, refund_cash);
    },
    SET_FRIEND_SHARE_PER({ state }, { user_id, friend_share_per }) {
        return api.cpu_user_info.set_friend_share_per(state.user_id, user_id, friend_share_per);
    },
    GET_USERLIST_SESCO({ state }, { min_referees, limit, include_banned }) {
        return api.cpu_user_info.get_userlist_sesco(state.user_id, min_referees, limit, include_banned);
    },
    GET_USER_SESCO_DETAIL({ state }, { user_id, ip_log_days }) {
        return api.cpu_user_info.get_user_sesco_detail(state.user_id, user_id, ip_log_days);
    },




    GET_SEARCH_USER_LIST({ state }, { keyword }) {
        return api.cpu_user_info.get_search_user_list(state.user_id, keyword);
    },
    GET_SEARCH_USER_ADID({ state }, { keyword }) {
        return api.cpu_user_info.get_search_user_adid(state.user_id, keyword);
    },
    // 전면 이벤트 관리
    CREATE_EVENT({ state }, { thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos }) {
        return api.cpu_user_info.create_event(state.user_id, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos);
    },
    GET_EVENT_LIST({ state }) {
        return api.cpu_user_info.get_event_list(state.user_id);
    },
    GET_EVENT({ state }, { pid }) {
        return api.cpu_user_info.get_event(state.user_id, pid);
    },
    EDIT_EVENT({ state }, { pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos }) {
        return api.cpu_user_info.edit_event(state.user_id, pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, campaign_id_ios, campaign_id_aos);
    },
    // 이벤트 롤링 관리
    GET_EVENT_ROLLING_LIST({ state }, { event_type } = {}) {
        return api.cpu_event_rolling.get_event_rolling_list(state.user_id, event_type);
    },
    CREATE_EVENT_ROLLING({ state }, { event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type }) {
        return api.cpu_event_rolling.create_event_rolling(state.user_id, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type);
    },
    EDIT_EVENT_ROLLING({ state }, { pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type }) {
        return api.cpu_event_rolling.edit_event_rolling(state.user_id, pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info, event_type);
    },
    CPU_SET_MAIN_BANNER({ state }, { pid, event_type }) {
        return api.cpu_event_rolling.set_main_banner(state.user_id, pid, event_type);
    },
    // 이벤트 미션 (PUBLIC_EVENT_MISSION)
    GET_EVENT_MISSION_LIST({ state }) {
        return api.cpu_event_mission.get_event_mission_list(state.user_id);
    },
    GET_EVENT_MISSION({ state }, { pid }) {
        return api.cpu_event_mission.get_event_mission(state.user_id, pid);
    },
    CREATE_EVENT_MISSION({ state }, { title, thumb, start_dt, end_dt, is_enable, info }) {
        return api.cpu_event_mission.create_event_mission(state.user_id, title, thumb, start_dt, end_dt, is_enable, info);
    },
    EDIT_EVENT_MISSION({ state }, { pid, title, thumb, start_dt, end_dt, is_enable, info }) {
        return api.cpu_event_mission.edit_event_mission(state.user_id, pid, title, thumb, start_dt, end_dt, is_enable, info);
    },
    // 티켓 럭키볼 (PUBLIC_EVENT_TICKET_LUCKYBALL)
    GET_EVENT_TICKET_LUCKYBALL_LIST({ state }) {
        return api.cpu_event_ticket_luckyball.get_event_ticket_luckyball_list(state.user_id);
    },
    CREATE_EVENT_TICKET_LUCKYBALL({ state }, { title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count }) {
        return api.cpu_event_ticket_luckyball.create_event_ticket_luckyball(state.user_id, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count);
    },
    EDIT_EVENT_TICKET_LUCKYBALL({ state }, { pid, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count }) {
        return api.cpu_event_ticket_luckyball.edit_event_ticket_luckyball(state.user_id, pid, title, desc, thumb, thumb_banner, start_dt, end_dt, is_enable, info, ticket_count);
    },
    // 이벤트 검수 (PUB_REVIEW_VERIFY)
    CPU_GET_REVIEW_LIST_NOT_VERIFY({ state }, payload) {
        return api.cpu_review_verify.get_review_list_not_verify(state.user_id, payload && payload.review_type);
    },
    CPU_GET_REVIEW_LIST_VERIFY_ALL({ state }, payload) {
        return api.cpu_review_verify.get_review_list_verify_all(state.user_id, payload && payload.review_type);
    },
    CPU_SET_REVIEW_LIST_APPROVE({ state }, { pids }) {
        return api.cpu_review_verify.set_review_list_approve(state.user_id, pids);
    },
    CPU_SET_REVIEW_LIST_REFUSE({ state }, { pids, rejection_reason }) {
        return api.cpu_review_verify.set_review_list_refuse(state.user_id, pids, rejection_reason);
    },

    // [퀴즈앤캐시] 이벤트 검수 (PUB_REVIEW_VERIFY)
    QUIZNCASH_GET_REVIEW_LIST_NOT_VERIFY({ state }, payload) {
        return api.quizncash_review_verify.get_review_list_not_verify(state.user_id, payload && payload.review_type);
    },
    QUIZNCASH_GET_REVIEW_LIST_VERIFY_ALL({ state }, payload) {
        return api.quizncash_review_verify.get_review_list_verify_all(state.user_id, payload && payload.review_type);
    },
    QUIZNCASH_SET_REVIEW_LIST_APPROVE({ state }, { pids }) {
        return api.quizncash_review_verify.set_review_list_approve(state.user_id, pids);
    },
    QUIZNCASH_SET_REVIEW_LIST_REFUSE({ state }, { pids, rejection_reason }) {
        return api.quizncash_review_verify.set_review_list_refuse(state.user_id, pids, rejection_reason);
    },
    GET_USER_INFO({ state }, { target_user }) {
        return api.cpu_user_info.get_user_info(state.user_id, target_user);
    },
    SET_USER_INFO_DATA({ state }, { user_id, data }) {
        return api.cpu_user_info.set_user_info_data(state.user_id, user_id, data);
    },
    CPU_SET_REVIEW_STATE_REWARD({ state }, { user_id }) {
        return api.cpu_user_info.set_review_state_reward(state.user_id, user_id);
    },
    CPU_SET_WIDGET_REVIEW_STATE_REWARD({ state }, { user_id }) {
        return api.cpu_user_info.set_widget_review_state_reward(state.user_id, user_id);
    },
    GET_GOODS_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.cpu_user_info.get_goods_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    GET_CHAT_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.cpu_user_info.get_chat_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    GET_MAIL_USERINFO_LIST_NICK({ state }, { packageName, nicklist, server_index }) {
        return api.cpu_user_info.get_search_user_nick(state.user_id, packageName, nicklist, server_index);
    },







    //////////////////////////[ COUPON ]//////////////////////////
    CREATE_COUPON({ state }, { coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id }) {
        return api.cpu_coupon.create_coupon(state.user_id, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id);
    },
    GET_RECENT_COUPONLIST({ state }) {
        return api.cpu_coupon.get_recent_couponlist(state.user_id);
    },
    GET_COUPON_LIST({ state }, { coupon_pid }) {
        return api.cpu_coupon.get_coupon_list(state.user_id, coupon_pid);
    },
    CHECK_DOUBLE_COUPON_ID({ state }, { custom_coupon_id }) {
        return api.cpu_coupon.check_double_coupon_id(state.user_id, custom_coupon_id);
    },
    //////////////////////////[ MAIL ]//////////////////////////
    CREATE_MAIL({ state }, { mail_type, user_id, mail_info, expire_start, expire_end }) {
        return api.cpu_mail.create_mail(state.user_id, mail_type, user_id, mail_info, expire_start, expire_end)
    },
    EDIT_MAIL({ state }, { mail_no, mail_info, expire_start, expire_end }) {
        return api.cpu_mail.edit_mail(state.user_id, mail_no, mail_info, expire_start, expire_end)
    },
    // eslint-disable-next-line no-empty-pattern
    GET_MAIL_LIST_RECENT({ state }, { }) {
        return api.cpu_mail.get_mail_list_recent(state.user_id)
    },
    GET_MAIL_LIST_TARGET({ state }, { user_id }) {
        return api.cpu_mail.get_mail_list_target(state.user_id, user_id);
    },
    CREATE_MAIL_MULTI({ state }, { user_list, mail_info, expire_start, expire_end }) {
        return api.cpu_mail.create_mail_multi(state.user_id, user_list, mail_info, expire_start, expire_end)
    },



    //////////////////////////[ NOTICE ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    GET_NOTICE_LIST({ state }, { }) {
        return api.cpu_notice.get_notice_list(state.user_id);
    },
    SET_NOTICE_INFO({ state }, { notice_title, notice_message, enable_yn, pid }) {
        return api.cpu_notice.set_notice(state.user_id, notice_title, notice_message, enable_yn, pid);
    },
    GET_NOTICE_INFO({ state }, { pid }) {
        return api.cpu_notice.get_notice(pid);
    },

    CREATE_NOTICE({ state }, { notice_title, notice_message }) {
        return api.cpu_notice.create_notice(state.user_id, notice_title, notice_message);
    },

    //////////////////////////[ GAME SETTING ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    GET_GAME_SETTING({ state }, { }) {
        return api.cpu_setting.get_game_setting(state.user_id);
    },
    SET_GAME_SETTING({ state }, { packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name }) {
        console.log("SET_GAME_SETTING :  " + packageName);
        console.log("SET_GAME_SETTING :  " + aos_ver);
        console.log("SET_GAME_SETTING :  " + ios_ver);
        console.log("SET_GAME_SETTING :  " + server_state_aos);
        console.log("SET_GAME_SETTING :  " + server_state_ios);
        console.log("SET_GAME_SETTING :  " + service_opt);
        return api.cpu_setting.set_game_setting(state.user_id, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name);
    },
    ADD_UPLOAD_TABLE_INFO({ state }, { packageName, version, user_id, file_path }) {
        return api.cpu_setting.add_upload_table_info(state.user_id, packageName, version, user_id, file_path);
    },
    GET_UPLOAD_TABLE_INFO({ state }, { packageName }) {
        return api.cpu_setting.get_upload_table_info(state.user_id, packageName);
    },
    USER_KICK({ state }, { packageName }) {
        return api.cpu_setting.user_kick(state.user_id, packageName);
    },
    DELETE_USER_ALL({ state }, { packageName }) {
        return api.cpu_setting.delete_user_all(packageName);
    },
    DELETE_USER({ state }, { packageName, user_id }) {
        return api.cpu_setting.delete_user(state.user_id, packageName, user_id);
    },
    GET_SERVER_TIME({ state }, { packageName }) {
        return api.cpu_setting.get_server_time(state.user_id, packageName);
    },
    SET_SERVER_TIME({ state }, { packageName, serverTime }) {
        return api.cpu_setting.set_server_time(state.user_id, packageName, serverTime);
    },
    ROLLBACK_SERVER_TIME({ state }, { packageName }) {
        return api.cpu_setting.rollback_server_time(state.user_id, packageName);
    },

    //////////////////////////[ Report 통계관련부 ]//////////////////////////
    GET_LOG({ state }, { log_type, start_date, end_date }) {
        return api.reports.get_log(log_type, start_date, end_date);
    },
    GET_LOG_TODAY({ state }, { log_type }) {
        return api.reports.get_log_today(log_type);
    },
    GET_LOG_HISTORY({ state }) {
        return api.reports.get_log_history(state.user_id);
    },
    ADD_LOG_EVENT({ state }, { packageName, event_name, event_key }) {
        return api.reports.add_log_event(state.user_id, packageName, event_name, event_key);
    },


    //////////////////////////[ 템플릿 업로드 로그 가져오기 ]//////////////////////////
    GET_TEMPLATE_LOG({ state }, { packageName }) {
        return api.template.get_template_logs(packageName);
    },
    INSERT_TEMPLATE_LOG({ state }, { packageName, templateVer, comment, file_path, isIOS }) {
        return api.template.insert_template_log(packageName, state.user_id, templateVer, comment, file_path, isIOS);
    },




    CPU_GET_SWAP_COIN_LIST({ state }) {
        return api.cpu.get_swap_coin_list(state.user_id);
    },
    CPU_CREATE_SWAP_COIN_INFO({ state }, { coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type }) {
        return api.cpu.create_swap_coin_info(state.user_id, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type);
    },
    CPU_EDIT_SWAP_COIN_INFO({ state }, { pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state }) {
        return api.cpu.edit_swap_coin_info(state.user_id, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state);
    },
    CPU_PM2_RESTART({ state }) {
        return api.cpu.pm2_restart(state.user_id);
    },
    CPU_GET_COIN_ORDER_LIST({ state }, { count }) {
        return api.cpu.get_coin_order_list(state.user_id, count);
    },
    CPU_SEARCH_COIN_ORDER_LIST({ state }, { user_id }) {
        return api.cpu.search_coin_order_list(state.user_id, user_id);
    },
    CPU_EDIT_COIN_ORDER_STATE({ state }, { pid, process_state, comment }) {
        return api.cpu.edit_coin_order_state(state.user_id, pid, process_state, comment);
    },

    CPU_GET_CASH_ORDER_LIST({ state }, { count }) {
        return api.cpu.get_cash_order_list(state.user_id, count);
    },
    CPU_SEARCH_CASH_ORDER_LIST({ state }, { user_id }) {
        return api.cpu.search_cash_order_list(state.user_id, user_id);
    },
    CPU_EDIT_CASH_ORDER_STATE({ state }, { pid, process_state, comment }) {
        return api.cpu.edit_cash_order_state(state.user_id, pid, process_state, comment);
    },




    CPU_GET_YOUTUBE_VIDEO_INFO({ state }) {
        return api.cpu.get_youtube_video_info(state.user_id);
    },

    CPU_REGIST_YOUTUBE_VIDEO_INFO({ state }, { yt_video_id, comment, user_id }) {
        return api.cpu.regist_youtube_video_info(state.user_id, yt_video_id, comment, user_id);
    },

    CPU_EDIT_YOUTUBE_VIDEO_INFO({ state }, { pid, comment, user_id, activate }) {
        return api.cpu.edit_youtube_video_info(state.user_id, pid, comment, user_id, activate);
    },

    CPU_GET_YOUTUBE_REPORT_INFO({ state }, { pid, process_state, comment }) {
        return api.cpu.get_youtube_report_info(state.user_id, pid, process_state, comment);
    },

    CPU_EDIT_YOUTUBE_REPORT_INFO({ state }, { pid, activate }) {
        return api.cpu.edit_youtube_report_info(state.user_id, pid, activate);
    },



    //#endregion















    //*************[ 퀴즈앤캐시 ]  */
    //#region [ 퀴즈앤캐시 ]

    QUIZANDCASH_BAN_USER({ state }, { packageName, target_user, exp, exp_info, server_index }) {
        return api.quizncash_user_info.ban_user(state.user_id, packageName, target_user, exp, exp_info, server_index);
    },
    QUIZANDCASH_UNBAN_USER({ state }, { target_user }) {
        return api.quizncash_user_info.unban_user(state.user_id, target_user);
    },

    QUIZANDCASH_GET_USERLIST_RECENT({ state }, { count }) {
        return api.quizncash_user_info.get_userlist_recent(state.user_id, count);
    },
    QUIZANDCASH_GET_USERLIST_REFEREE({ state }, { count }) {
        return api.quizncash_user_info.get_userlist_referee(state.user_id, count);
    },
    QUIZANDCASH_GET_USERLIST_ENJOY_AD({ state }, { count, type }) {
        return api.quizncash_user_info.get_userlist_enjoy_ad(state.user_id, count, type);
    },
    QUIZANDCASH_GET_USERLIST_HAVE_COIN({ state }, { count, type }) {
        return api.quizncash_user_info.get_userlist_have_coin(state.user_id, count, type);
    },

    QUIZANDCASH_CHANGE_USER_NICK_NAME({ state }, { user_id, nick }) {
        return api.quizncash_user_info.change_user_nick_name(state.user_id, user_id, nick);
    },
    QUIZANDCASH_SET_USER_PHONE_NUMBER({ state }, { user_id, phone }) {
        return api.quizncash_user_info.set_user_phone_number(state.user_id, user_id, phone);
    },
    QUIZANDCASH_RESET_USER_PHONE({ state }, { user_id }) {
        return api.quizncash_user_info.reset_user_phone(state.user_id, user_id);
    },

    QUIZANDCASH_GET_USER_REFEREE_LIST({ state }, { user_id }) {
        return api.quizncash_user_info.get_user_referee_list(state.user_id, user_id);
    },
    QUIZANDCASH_GET_USER_CPU_LIST({ state }, { user_id }) {
        return api.quizncash_user_info.get_user_cpu_list(state.user_id, user_id);
    },
    QUIZANDCASH_GET_USER_CASHLOG_LIST({ state }, { user_id }) {
        return api.quizncash_user_info.get_user_cashlog_list(state.user_id, user_id);
    },

    //
    QUIZANDCASH_CPU_GET_USER_BUY_PRODUCTS({ state }) {
        return api.quizncash_user_buy_products.get_user_buy_products();
    },
    QUIZANDCASH_REFUND_USER_CPU({ state }, { user_id, bonus_log_pid, refund_cash }) {
        return api.quizncash_user_info.refund_user_cpu(state.user_id, user_id, bonus_log_pid, refund_cash);
    },




    QUIZANDCASH_GET_SEARCH_USER_LIST({ state }, { keyword }) {
        return api.quizncash_user_info.get_search_user_list(state.user_id, keyword);
    },
    QUIZANDCASH_GET_USER_INFO({ state }, { target_user }) {
        return api.quizncash_user_info.get_user_info(state.user_id, target_user);
    },
    QUIZANDCASH_SET_USER_INFO_DATA({ state }, { user_id, data }) {
        return api.quizncash_user_info.set_user_info_data(state.user_id, user_id, data);
    },
    QUIZANDCASH_GET_GOODS_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.quizncash_user_info.get_goods_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    QUIZANDCASH_GET_CHAT_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.quizncash_user_info.get_chat_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    QUIZANDCASH_GET_MAIL_USERINFO_LIST_NICK({ state }, { packageName, nicklist, server_index }) {
        return api.quizncash_user_info.get_search_user_nick(state.user_id, packageName, nicklist, server_index);
    },







    //////////////////////////[ COUPON ]//////////////////////////
    QUIZANDCASH_CREATE_COUPON({ state }, { coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id }) {
        return api.quizncash_coupon.create_coupon(state.user_id, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id);
    },
    QUIZANDCASH_GET_RECENT_COUPONLIST({ state }) {
        return api.quizncash_coupon.get_recent_couponlist(state.user_id);
    },
    QUIZANDCASH_GET_COUPON_LIST({ state }, { coupon_pid }) {
        return api.quizncash_coupon.get_coupon_list(state.user_id, coupon_pid);
    },
    QUIZANDCASH_CHECK_DOUBLE_COUPON_ID({ state }, { custom_coupon_id }) {
        return api.quizncash_coupon.check_double_coupon_id(state.user_id, custom_coupon_id);
    },
    //////////////////////////[ MAIL ]//////////////////////////
    QUIZANDCASH_CREATE_MAIL({ state }, { mail_type, user_id, mail_info, expire_start, expire_end }) {
        return api.quizncash_mail.create_mail(state.user_id, mail_type, user_id, mail_info, expire_start, expire_end)
    },
    // eslint-disable-next-line no-empty-pattern
    QUIZANDCASH_GET_MAIL_LIST_RECENT({ state }, { }) {
        return api.quizncash_mail.get_mail_list_recent(state.user_id)
    },
    QUIZANDCASH_GET_MAIL_LIST_TARGET({ state }, { user_id }) {
        return api.quizncash_mail.get_mail_list_target(state.user_id, user_id);
    },
    QUIZANDCASH_CREATE_MAIL_MULTI({ state }, { user_list, mail_info, expire_start, expire_end }) {
        return api.quizncash_mail.create_mail_multi(state.user_id, user_list, mail_info, expire_start, expire_end)
    },



    //////////////////////////[ NOTICE ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    QUIZANDCASH_GET_NOTICE_LIST({ state }, { }) {
        return api.quizncash_notice.get_notice_list(state.user_id);
    },
    QUIZANDCASH_SET_NOTICE_INFO({ state }, { notice_title, notice_message, enable_yn, pid }) {
        return api.quizncash_notice.set_notice(state.user_id, notice_title, notice_message, enable_yn, pid);
    },
    QUIZANDCASH_GET_NOTICE_INFO({ state }, { pid }) {
        return api.quizncash_notice.get_notice(pid);
    },

    QUIZANDCASH_CREATE_NOTICE({ state }, { notice_title, notice_message }) {
        return api.quizncash_notice.create_notice(state.user_id, notice_title, notice_message);
    },

    //////////////////////////[ GAME SETTING ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    QUIZANDCASH_GET_GAME_SETTING({ state }, { }) {
        return api.quizncash_setting.get_game_setting(state.user_id);
    },
    QUIZANDCASH_SET_GAME_SETTING({ state }, { packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name }) {
        console.log("SET_GAME_SETTING :  " + packageName);
        console.log("SET_GAME_SETTING :  " + aos_ver);
        console.log("SET_GAME_SETTING :  " + ios_ver);
        console.log("SET_GAME_SETTING :  " + server_state_aos);
        console.log("SET_GAME_SETTING :  " + server_state_ios);
        console.log("SET_GAME_SETTING :  " + service_opt);
        return api.quizncash_setting.set_game_setting(state.user_id, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name);
    },
    QUIZANDCASH_ADD_UPLOAD_TABLE_INFO({ state }, { packageName, version, user_id, file_path }) {
        return api.quizncash_setting.add_upload_table_info(state.user_id, packageName, version, user_id, file_path);
    },
    QUIZANDCASH_GET_UPLOAD_TABLE_INFO({ state }, { packageName }) {
        return api.quizncash_setting.get_upload_table_info(state.user_id, packageName);
    },
    QUIZANDCASH_USER_KICK({ state }, { packageName }) {
        return api.quizncash_setting.user_kick(state.user_id, packageName);
    },
    QUIZANDCASH_DELETE_USER_ALL({ state }, { packageName }) {
        return api.quizncash_setting.delete_user_all(packageName);
    },
    QUIZANDCASH_DELETE_USER({ state }, { packageName, user_id }) {
        return api.quizncash_setting.delete_user(state.user_id, packageName, user_id);
    },
    QUIZANDCASH_GET_SERVER_TIME({ state }, { packageName }) {
        return api.quizncash_setting.get_server_time(state.user_id, packageName);
    },
    QUIZANDCASH_SET_SERVER_TIME({ state }, { packageName, serverTime }) {
        return api.quizncash_setting.set_server_time(state.user_id, packageName, serverTime);
    },
    QUIZANDCASH_ROLLBACK_SERVER_TIME({ state }, { packageName }) {
        return api.quizncash_setting.rollback_server_time(state.user_id, packageName);
    },

    //////////////////////////[ Report 통계관련부 ]//////////////////////////
    QUIZANDCASH_GET_LOG({ state }, { log_type, start_date, end_date }) {
        return api.reports.get_log(log_type, start_date, end_date);
    },
    QUIZANDCASH_GET_LOG_TODAY({ state }, { log_type }) {
        return api.reports.get_log_today(log_type);
    },
    QUIZANDCASH_GET_LOG_HISTORY({ state }) {
        return api.reports.get_log_history(state.user_id);
    },
    QUIZANDCASH_ADD_LOG_EVENT({ state }, { packageName, event_name, event_key }) {
        return api.reports.add_log_event(state.user_id, packageName, event_name, event_key);
    },


    //////////////////////////[ 템플릿 업로드 로그 가져오기 ]//////////////////////////
    QUIZANDCASH_GET_TEMPLATE_LOG({ state }, { packageName }) {
        return api.template.get_template_logs(packageName);
    },
    QUIZANDCASH_INSERT_TEMPLATE_LOG({ state }, { packageName, templateVer, comment, file_path, isIOS }) {
        return api.template.insert_template_log(packageName, state.user_id, templateVer, comment, file_path, isIOS);
    },




    QUIZANDCASH_GET_SWAP_COIN_LIST({ state }) {
        return api.quizncash.get_swap_coin_list(state.user_id);
    },
    QUIZANDCASH_CREATE_SWAP_COIN_INFO({ state }, { coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type }) {
        return api.quizncash.create_swap_coin_info(state.user_id, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type);
    },
    QUIZANDCASH_EDIT_SWAP_COIN_INFO({ state }, { pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state }) {
        return api.quizncash.edit_swap_coin_info(state.user_id, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state);
    },
    QUIZANDCASH_PM2_RESTART({ state }) {
        return api.quizncash.pm2_restart(state.user_id);
    },
    QUIZANDCASH_GET_COIN_ORDER_LIST({ state }, { count }) {
        return api.quizncash.get_coin_order_list(state.user_id, count);
    },
    QUIZANDCASH_SEARCH_COIN_ORDER_LIST({ state }, { user_id }) {
        return api.quizncash.search_coin_order_list(state.user_id, user_id);
    },
    QUIZANDCASH_EDIT_COIN_ORDER_STATE({ state }, { pid, process_state, comment }) {
        return api.quizncash.edit_coin_order_state(state.user_id, pid, process_state, comment);
    },

    QUIZANDCASH_GET_CASH_ORDER_LIST({ state }, { count }) {
        return api.quizncash.get_cash_order_list(state.user_id, count);
    },
    QUIZANDCASH_SEARCH_CASH_ORDER_LIST({ state }, { user_id }) {
        return api.quizncash.search_cash_order_list(state.user_id, user_id);
    },
    QUIZANDCASH_EDIT_CASH_ORDER_STATE({ state }, { pid, process_state, comment }) {
        return api.quizncash.edit_cash_order_state(state.user_id, pid, process_state, comment);
    },




    QUIZANDCASH_GET_YOUTUBE_VIDEO_INFO({ state }) {
        return api.quizncash.get_youtube_video_info(state.user_id);
    },

    QUIZANDCASH_REGIST_YOUTUBE_VIDEO_INFO({ state }, { yt_video_id, comment, user_id }) {
        return api.quizncash.regist_youtube_video_info(state.user_id, yt_video_id, comment, user_id);
    },

    QUIZANDCASH_EDIT_YOUTUBE_VIDEO_INFO({ state }, { pid, comment, user_id, activate }) {
        return api.quizncash.edit_youtube_video_info(state.user_id, pid, comment, user_id, activate);
    },

    QUIZANDCASH_GET_YOUTUBE_REPORT_INFO({ state }, { pid, process_state, comment }) {
        return api.quizncash.get_youtube_report_info(state.user_id, pid, process_state, comment);
    },

    QUIZANDCASH_EDIT_YOUTUBE_REPORT_INFO({ state }, { pid, activate }) {
        return api.quizncash.edit_youtube_report_info(state.user_id, pid, activate);
    },
    QUIZANDCASH_GET_DASHBOARD_DATA({ state }) {
        return api.quizncash.get_dashboard_data(state.user_id);
    },
    QUIZANDCASH_GET_DAILY_SALES_STATISTICS({ state }) {
        return api.quizncash.get_daily_sales_statistics(state.user_id);
    },

    //////////////////////////[ 메인 퀴즈 정보 ]//////////////////////////
    CREATE_MAIN_QUIZ({ state }, { title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable }) {
        return api.quizncash_mainquiz.create_main_quiz(state.user_id, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable);
    },
    GET_MAIN_QUIZ_LIST({ state }) {
        return api.quizncash_mainquiz.get_main_quiz_list(state.user_id);
    },
    EDIT_MAIN_QUIZ({ state }, { pid, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable }) {
        return api.quizncash_mainquiz.edit_main_quiz(state.user_id, pid, title, desc, thumb, quiz_type, grade, step_count, participate, content_info, is_enable);
    },

    //////////////////////////[ 이벤트 롤링 ]//////////////////////////
    // [API 테스터] 퀴즈앤캐시
    QUIZNCASH_SEND_PUSH_BY_USERID({ state }, { user_id, title, message }) {
        return api.quizncash_dev.send_push_by_userid(state.user_id, user_id, title, message);
    },
    QUIZNCASH_OFFERWALL_TEST({ state }, { provider, user_id, user_pnt, adv_id, base_domain }) {
        return api.quizncash_dev.offerwall_test(state.user_id, provider, user_id, user_pnt, adv_id, base_domain);
    },
    QUIZNCASH_GET_RECENT_ADV_IDS({ state }) {
        return api.quizncash_dev.get_recent_adv_ids(state.user_id);
    },
    QUIZNCASH_GET_EVENT_ROLLING_LIST({ state }) {
        return api.quizncash_event_rolling.get_event_rolling_list(state.user_id);
    },
    QUIZNCASH_CREATE_EVENT_ROLLING({ state }, { event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info }) {
        return api.quizncash_event_rolling.create_event_rolling(state.user_id, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info);
    },
    QUIZNCASH_EDIT_EVENT_ROLLING({ state }, { pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info }) {
        return api.quizncash_event_rolling.edit_event_rolling(state.user_id, pid, event_tag, title, desc, thumb, start_dt, end_dt, is_enable, info);
    },

    //#endregion





    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //////////////////////////[ 퀴즈 관련 API  ]//////////////////////////
    //************** [ 스냅퀴즈 ]  */ 
    //#region [스냅퀴즈]
    //퀴즈 번들 만들기 
    CREATE_QUIZ_BUNDLE({ state }, { category, category_comment, img_path, desc_text, ref_pid }) {
        return api.quizinfo.create_quiz_bundle(state.user_id, category, category_comment, img_path, desc_text, ref_pid);
    },
    //퀴즈 번들 리스트 가져오기 
    GET_QUIZBUNDLE_LIST({ state }) {
        return api.quizinfo.get_quizbundle_list(state.user_id);
    },
    GET_QUIZBUNDLE_INFO({ state }, { pid }) {
        return api.quizinfo.get_quizbundle_info(pid);
    },
    //퀴즈 번들 수정하기 
    EDIT_QUIZBUNDLE({ state }, { pid, category, category_comment, level, img_path, desc_text }) {
        return api.quizinfo.edit_quizbundle(state.user_id, pid, category, category_comment, level, img_path, desc_text);
    },
    //퀴즈 번들 삭제하기
    DELETE_QUIZBUNDLE({ state }, { pid }) {
        return api.quizinfo.delete_quizbundle(state.user_id, pid);
    },

    COMMIT_QUIZBUNDLE({ state }, { pid, commit_path }) {
        return api.quizinfo.commit_quizbundle(state.user_id, pid, commit_path);
    },



    CREATE_QUIZ({ state }, { bundle_pid, correct, answer, img_path, need_ad, hide_type }) {
        return api.quizinfo.create_quiz(state.user_id, bundle_pid, correct, answer, img_path, need_ad, hide_type);
    },
    GET_QUIZLIST({ state }, { bundle_pid }) {
        return api.quizinfo.get_quizlist(state.user_id, bundle_pid);
    },
    EDIT_QUIZ_INFO({ state }, { bundle_pid, pid, correct, answer, img_path, need_ad, hide_type }) {
        return api.quizinfo.edit_quiz_info(bundle_pid, pid, correct, answer, img_path, need_ad, hide_type);
    },

    DELETE_QUIZ({ state }, { pid, bundle_pid }) {
        return api.quizinfo.delete_quiz(state.user_id, pid, bundle_pid);
    },

    GET_QUIZ_GROUP_INFO({ state }) {
        return api.quizinfo.get_quiz_group_info(state.user_id);
    },
    CREATE_QUIZ_GROUP({ state }, { title, comment, count, quiz_type, quiz_count }) {
        return api.quizinfo.create_quiz_group(state.user_id, title, comment, count, quiz_type, quiz_count);
    },
    GET_QUIZ_GROUP_ITEMINFO({ state }, { group_pid }) {
        return api.quizinfo.get_quiz_group_iteminfo(state.user_id, group_pid);
    },
    SET_QUIZ_GROUP_ITEMINFO({ state }, { group_pid, quiz_items, etc_info, quiz_count }) {
        return api.quizinfo.set_quiz_group_iteminfo(state.user_id, group_pid, quiz_items, etc_info, quiz_count);
    },




    //퀴즈 번들 만들기 
    CREATE_TEST_BUNDLE({ state }, { title, desc_text, img_path_small, img_path_big, participants, category }) {
        return api.quizinfo.create_test_bundle(state.user_id, title, desc_text, img_path_small, img_path_big, participants, category);
    },
    //퀴즈 번들 리스트 가져오기 
    GET_TESTBUNDLE_LIST({ state }) {
        return api.quizinfo.get_testbundle_list(state.user_id);
    },
    GET_TESTBUNDLE_INFO({ state }, { pid }) {
        return api.quizinfo.get_testbundle_info(pid);
    },
    SET_TESTBUNDLE_MAIN({ state }, { pid }) {
        return api.quizinfo.set_testbundle_main(pid);
    },
    GET_TESTBUNDLE_MAIN({ state }) {
        return api.quizinfo.get_testbundle_main();
    },
    //퀴즈 번들 수정하기 
    EDIT_TESTBUNDLE({ state }, { pid, title, desc_text, img_path_small, img_path_big, test_count, is_main, participants, category }) {
        return api.quizinfo.edit_testbundle(state.user_id, pid, title, desc_text, img_path_small, img_path_big, test_count, is_main, participants, category);
    },
    //퀴즈 번들 삭제하기
    DELETE_TESTBUNDLE({ state }, { pid }) {
        return api.quizinfo.delete_testbundle(state.user_id, pid);
    },

    COMMIT_TESTBUNDLE({ state }, { pid, commit_path }) {
        return api.quizinfo.commit_testbundle(pid, commit_path);
    },




    CREATE_TEST({ state }, { bundle_pid, test_data, need_ad }) {
        return api.quizinfo.create_test(state.user_id, bundle_pid, test_data, need_ad);
    },
    GET_TEST_LIST({ state }, { bundle_pid }) {
        return api.quizinfo.get_test_list(bundle_pid);
    },
    DELETE_TEST({ state }, { bundle_pid, pid }) {
        return api.quizinfo.delete_test(bundle_pid, pid);
    },
    EDIT_TEST({ state }, { bundle_pid, pid, test_data, need_ad }) {
        return api.quizinfo.edit_test(bundle_pid, pid, test_data, need_ad);
    },

    GET_TEST_LIST_RESULT({ state }, { bundle_pid }) {
        return api.quizinfo.get_test_list_result(bundle_pid);
    },
    CREATE_TEST_RESULT({ state }, { bundle_pid, title, desc, img_path, score_start, score_end }) {
        //admin_user, bundle_pid ,  title, desc, img_path , score_start, score_end
        return api.quizinfo.create_test_result(state.user_id, bundle_pid, title, desc, img_path, score_start, score_end);
    },
    DELETE_TEST_RESULT({ state }, { bundle_pid, pid }) {
        return api.quizinfo.delete_test_result(bundle_pid, pid);
    },
    EDIT_TEST_RESULT({ state }, { bundle_pid, pid, title, desc, img_path, score_start, score_end }) {
        return api.quizinfo.edit_test_result(bundle_pid, pid, title, desc, img_path, score_start, score_end);
    },






    GET_IMG_QUIZLIST_AD({ state }) {
        return api.quizinfo.get_img_quizlist_ad();
    },
    GET_RANDOM_IMG_QUIZLIST_AD({ state }, { item_count }) {
        return api.quizinfo.get_random_img_quizlist_ad(item_count);
    },
    CREATE_QUIZLIST_AD({ state }, { title, quiz_data, commit_path }) {
        return api.quizinfo.create_quizlist_ad(state.user_id, title, quiz_data, commit_path);
    },
    DELETE_QUIZLIST_AD({ state }, { pid }) {
        return api.quizinfo.delete_quizlist_ad(pid);
    },
    UPDATE_AD_QUIZ_STATE({ state }, { pid, quiz_state }) {
        return api.quizinfo.update_ad_quiz_state(pid, quiz_state);
    },




    GET_PARTNER_INFO({ state }, { pid }) {
        return api.quizinfo.get_partner_info(pid);
    },
    GET_PARTNER_LIST({ state }) {
        return api.quizinfo.get_partner_list();
    },
    CREATE_PARTNER({ state }, { partner_key, partner_name, desc_text, callback_url, thumb_url }) {
        return api.quizinfo.create_partner(partner_key, partner_name, desc_text, callback_url, thumb_url);
    },
    EDIT_PARTNER_INFO({ state }, { pid, partner_name, desc_text, callback_url, thumb_url }) {
        return api.quizinfo.edit_partner_info(pid, partner_name, desc_text, callback_url, thumb_url);
    },
    GET_IMG_QUIZ_REPORT({ state }, { start_dt, end_date }) {
        return api.quizinfo.get_img_quiz_report(start_dt, end_date);
    },
    LOAD_QUIZ_LOG_VISIT_MAIN({ state }, { item_count }) {
        return api.quizinfo.load_quiz_log_visit_main(item_count);
    },


    CREATE_QUIZ_TEMPLATE({ state }, { partner_key, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key }) {
        return api.quizinfo.create_quiz_template(partner_key, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key);
    },
    GET_QUIZ_TEMPLATE_LIST({ state }, { partner_key }) {
        return api.quizinfo.get_quiz_template_list(partner_key);
    },
    EDIT_QUIZ_TEMPLATE({ state }, { pid, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key }) {
        return api.quizinfo.edit_quiz_template(pid, title, desc_text, thumb_url, activate, activation_type, activation_start, activation_end, ref_group_pid, quiz_type, adm_api_key);
    },

    //////////////////////////[ NOTICE ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    GET_QUIZ_NOTICE_LIST({ state }, { }) {
        return api.quizinfo.get_notice_list(state.user_id);
    },
    SET_QUIZ_NOTICE_INFO({ state }, { notice_title, notice_message, enable_yn, pid }) {
        return api.quizinfo.set_notice(state.user_id, notice_title, notice_message, enable_yn, pid);
    },
    GET_QUIZ_NOTICE_INFO({ state }, { pid }) {
        return api.quizinfo.get_notice(pid);
    },

    CREATE_QUIZ_NOTICE({ state }, { notice_title, notice_message }) {
        return api.quizinfo.create_notice(state.user_id, notice_title, notice_message);
    },

    //////////////////////////[ 보상형 하우스애드 ]//////////////////////////
    GET_REWARD_AD_LIST({ state }) {
        return api.snapquiz_housead.get_reward_ad_list(state.user_id);
    },
    GET_REWARD_AD_DETAIL({ state }, { id }) {
        return api.snapquiz_housead.get_reward_ad_detail(id);
    },
    SAVE_REWARD_AD({ state }, payload) {
        return api.snapquiz_housead.save_reward_ad({ admin_user: state.user_id, ...payload });
    },
    DELETE_REWARD_AD({ state }, { id }) {
        return api.snapquiz_housead.delete_reward_ad(id);
    },
    SET_REWARD_AD_ACTIVE({ state }, { id, is_active }) {
        return api.snapquiz_housead.set_reward_ad_active(id, is_active);
    },
    GET_REWARD_AD_STATS({ state }, { id, start_date, end_date }) {
        return api.snapquiz_housead.get_reward_ad_stats(id, start_date, end_date);
    },
    GET_REWARD_AD_DASHBOARD({ state }) {
        return api.snapquiz_housead.get_reward_ad_dashboard(state.user_id);
    },

    // 그림 퀴즈 관리
    CREATE_DRAWING_QUIZ({ state }, { correct, answer, img_path, activate }) {
        return api.quizinfo.create_drawing_quiz(state.user_id, correct, answer, img_path, activate);
    },
    GET_DRAWING_QUIZ_LIST({ state }) {
        return api.quizinfo.get_drawing_quiz_list();
    },
    EDIT_DRAWING_QUIZ({ state }, { pid, correct, answer, img_path, activate }) {
        return api.quizinfo.edit_drawing_quiz(pid, correct, answer, img_path, activate);
    },
    DELETE_DRAWING_QUIZ({ state }, { pid }) {
        return api.quizinfo.delete_drawing_quiz(pid);
    },



    //#endregion







    //*************[ 금나르기 ]  */
    //#region [ 금나르기 ]

    // [애플 계정이전 CS 복구] AUTH_ID 스왑 + 매칭
    CARRYGOLD_AUTH_RECOVER_SEARCH({ state }, { phone, nick, user_id }) {
        return api.carrygold_auth_recover.search(state.user_id, phone, nick, user_id);
    },
    CARRYGOLD_AUTH_RECOVER_USER_IPS({ state }, { user_id }) {
        return api.carrygold_auth_recover.user_ips(state.user_id, user_id);
    },
    CARRYGOLD_AUTH_RECOVER_MATCH_IP({ state }, { user_id }) {
        return api.carrygold_auth_recover.match_ip(state.user_id, user_id);
    },
    CARRYGOLD_AUTH_RECOVER_APPLY({ state }, { user_id_old, user_id_new, reason }) {
        return api.carrygold_auth_recover.apply_swap(state.user_id, user_id_old, user_id_new, reason);
    },
    CARRYGOLD_AUTH_RECOVER_LOG({ state }, { user_id }) {
        return api.carrygold_auth_recover.get_log(state.user_id, user_id);
    },

    CARRYGOLD_BAN_USER({ state }, { packageName, target_user, exp, exp_info, server_index }) {
        return api.carrygold_user_info.ban_user(state.user_id, packageName, target_user, exp, exp_info, server_index);
    },
    CARRYGOLD_UNBAN_USER({ state }, { target_user }) {
        return api.carrygold_user_info.unban_user(state.user_id, target_user);
    },

    CARRYGOLD_GET_USERLIST_RECENT({ state }, { count }) {
        return api.carrygold_user_info.get_userlist_recent(state.user_id, count);
    },
    CARRYGOLD_GET_USERLIST_REFEREE({ state }, { count }) {
        return api.carrygold_user_info.get_userlist_referee(state.user_id, count);
    },
    CARRYGOLD_GET_USERLIST_ENJOY_AD({ state }, { count, type }) {
        return api.carrygold_user_info.get_userlist_enjoy_ad(state.user_id, count, type);
    },
    CARRYGOLD_GET_USERLIST_HAVE_COIN({ state }, { count, type }) {
        return api.carrygold_user_info.get_userlist_have_coin(state.user_id, count, type);
    },
    CARRYGOLD_GET_USERLIST_HAVE_GEM({ state }, { count, type }) {
        return api.carrygold_user_info.get_userlist_have_gem(state.user_id, count, type);
    },
    CARRYGOLD_GET_USERLIST_SESCO({ state }, { min_referees, limit, include_banned }) {
        return api.carrygold_user_info.get_userlist_sesco(state.user_id, min_referees, limit, include_banned);
    },
    CARRYGOLD_GET_USER_SESCO_DETAIL({ state }, { user_id, ip_log_days }) {
        return api.carrygold_user_info.get_user_sesco_detail(state.user_id, user_id, ip_log_days);
    },

    // 금나르기 — 전면 이벤트 관리 (PUBLIC_EVENT_NOTI)
    CARRYGOLD_CREATE_EVENT({ state }, { thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos }) {
        return api.carrygold_event.create_event(state.user_id, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos);
    },
    CARRYGOLD_GET_EVENT_LIST({ state }) {
        return api.carrygold_event.get_event_list(state.user_id);
    },
    CARRYGOLD_GET_EVENT({ state }, { pid }) {
        return api.carrygold_event.get_event(state.user_id, pid);
    },
    CARRYGOLD_EDIT_EVENT({ state }, { pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos }) {
        return api.carrygold_event.edit_event(state.user_id, pid, thumb_url, link_type, link_path, title, desc_text, button_text, is_important, priority, enable_yn, sub_param, campaign_id_ios, campaign_id_aos);
    },
    CARRYGOLD_GET_USERLIST_HAVE_BP({ state }, { count }) {
        return api.carrygold_user_info.get_userlist_have_bp(state.user_id, count);
    },
    CARRYGOLD_SET_FRIEND_SHARE_PER({ state }, { user_id, friend_share_per }) {
        return api.carrygold_user_info.set_friend_share_per(state.user_id, user_id, friend_share_per);
    },

    CARRYGOLD_CHANGE_USER_NICK_NAME({ state }, { user_id, nick }) {
        return api.carrygold_user_info.change_user_nick_name(state.user_id, user_id, nick);
    },
    CARRYGOLD_SET_USER_PHONE_NUMBER({ state }, { user_id, phone }) {
        return api.carrygold_user_info.set_user_phone_number(state.user_id, user_id, phone);
    },
    CARRYGOLD_RESET_USER_PHONE({ state }, { user_id }) {
        return api.carrygold_user_info.reset_user_phone(state.user_id, user_id);
    },

    CARRYGOLD_GET_USER_REFEREE_LIST({ state }, { user_id }) {
        return api.carrygold_user_info.get_user_referee_list(state.user_id, user_id);
    },
    CARRYGOLD_GET_USER_CPU_LIST({ state }, { user_id }) {
        return api.carrygold_user_info.get_user_cpu_list(state.user_id, user_id);
    },
    CARRYGOLD_GET_USER_CASHLOG_LIST({ state }, { user_id }) {
        return api.carrygold_user_info.get_user_cashlog_list(state.user_id, user_id);
    },
    CARRYGOLD_GET_USER_GEMLOG_LIST({ state }, { user_id, start_dt, end_dt }) {
        return api.carrygold_user_info.get_user_gemlog_list(state.user_id, user_id, start_dt, end_dt);
    },

    //
    CARRYGOLD_REFUND_USER_CPU({ state }, { user_id, bonus_log_pid, refund_cash }) {
        return api.carrygold_user_info.refund_user_cpu(state.user_id, user_id, bonus_log_pid, refund_cash);
    },
    CARRYGOLD_REFUND_GEM_LOG({ state }, { gem_log_pid }) {
        return api.carrygold_user_info.refund_gem_log(state.user_id, gem_log_pid);
    },




    CARRYGOLD_GET_SEARCH_USER_LIST({ state }, { keyword }) {
        return api.carrygold_user_info.get_search_user_list(state.user_id, keyword);
    },
    CARRYGOLD_GET_USER_INFO({ state }, { target_user }) {
        return api.carrygold_user_info.get_user_info(state.user_id, target_user);
    },
    CARRYGOLD_SET_REVIEW_STATE_REWARD({ state }, { user_id }) {
        return api.carrygold_user_info.set_review_state_reward(state.user_id, user_id);
    },
    CARRYGOLD_SET_USER_INFO_DATA({ state }, { user_id, data }) {
        return api.carrygold_user_info.set_user_info_data(state.user_id, user_id, data);
    },
    CARRYGOLD_GET_GOODS_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.carrygold_user_info.get_goods_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    CARRYGOLD_GET_CHAT_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.carrygold_user_info.get_chat_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    CARRYGOLD_GET_MAIL_USERINFO_LIST_NICK({ state }, { packageName, nicklist, server_index }) {
        return api.carrygold_user_info.get_search_user_nick(state.user_id, packageName, nicklist, server_index);
    },







    //////////////////////////[ COUPON ]//////////////////////////
    CARRYGOLD_CREATE_COUPON({ state }, { coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id }) {
        return api.carrygold_coupon.create_coupon(state.user_id, coupon_type, coupon_item, coupon_exp, expire_dt, count, custom_coupon_id);
    },
    CARRYGOLD_GET_RECENT_COUPONLIST({ state }) {
        return api.carrygold_coupon.get_recent_couponlist(state.user_id);
    },
    CARRYGOLD_GET_COUPON_LIST({ state }, { coupon_pid }) {
        return api.carrygold_coupon.get_coupon_list(state.user_id, coupon_pid);
    },
    CARRYGOLD_CHECK_DOUBLE_COUPON_ID({ state }, { custom_coupon_id }) {
        return api.carrygold_coupon.check_double_coupon_id(state.user_id, custom_coupon_id);
    },
    //////////////////////////[ MAIL ]//////////////////////////
    CARRYGOLD_CREATE_MAIL({ state }, { mail_type, user_id, mail_info, expire_start, expire_end }) {
        return api.carrygold_mail.create_mail(state.user_id, mail_type, user_id, mail_info, expire_start, expire_end)
    },
    CARRYGOLD_EDIT_MAIL({ state }, { mail_no, mail_info, expire_start, expire_end }) {
        return api.carrygold_mail.edit_mail(state.user_id, mail_no, mail_info, expire_start, expire_end)
    },
    // eslint-disable-next-line no-empty-pattern
    CARRYGOLD_GET_MAIL_LIST_RECENT({ state }, { }) {
        return api.carrygold_mail.get_mail_list_recent(state.user_id)
    },
    CARRYGOLD_GET_MAIL_LIST_TARGET({ state }, { user_id }) {
        return api.carrygold_mail.get_mail_list_target(state.user_id, user_id);
    },
    CARRYGOLD_CREATE_MAIL_MULTI({ state }, { user_list, mail_info, expire_start, expire_end }) {
        return api.carrygold_mail.create_mail_multi(state.user_id, user_list, mail_info, expire_start, expire_end)
    },



    //////////////////////////[ NOTICE ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    CARRYGOLD_GET_NOTICE_LIST({ state }, { }) {
        return api.carrygold_notice.get_notice_list(state.user_id);
    },
    CARRYGOLD_SET_NOTICE_INFO({ state }, { notice_title, notice_message, enable_yn, pid }) {
        return api.carrygold_notice.set_notice(state.user_id, notice_title, notice_message, enable_yn, pid);
    },
    CARRYGOLD_GET_NOTICE_INFO({ state }, { pid }) {
        return api.carrygold_notice.get_notice(pid);
    },

    CARRYGOLD_CREATE_NOTICE({ state }, { notice_title, notice_message }) {
        return api.carrygold_notice.create_notice(state.user_id, notice_title, notice_message);
    },

    CARRYGOLD_GET_NOTICE_LIST_NOT_VERIFY({ state }, payload) {
        return api.carrygold_notice.get_notice_list_not_verify(state.user_id, payload && payload.review_type);
    },
    CARRYGOLD_GET_NOTICE_LIST_VERIFY_ALL({ state }, payload) {
        return api.carrygold_notice.get_notice_list_verify_all(state.user_id, payload && payload.review_type);
    },
    CARRYGOLD_SET_NOTICE_LIST_VERIFY({ state }, { pids, verified_state, reason, review_type }) {
        if (verified_state === 'Y') {
            return api.carrygold_notice.set_notice_list_approve(state.user_id, pids, review_type);
        } else {
            return api.carrygold_notice.set_notice_list_refuse(state.user_id, pids, reason, review_type);
        }
    },
    CARRYGOLD_CREATE_NOTICE_VERIFY({ state }, { USER_ID, IMAGE, TITLE, MESSAGE, PRODUCT_PID, NOTICE_TYPE, ENABLE_REPLY, REVIEW_TYPE }) {
        return api.carrygold_notice.create_notice_verify(USER_ID, IMAGE, TITLE, MESSAGE, PRODUCT_PID, NOTICE_TYPE, ENABLE_REPLY, REVIEW_TYPE);
    },

    //////////////////////////[ CHAT MANAGE ]//////////////////////////
    CARRYGOLD_GET_CHAT_LIST({ state }, { count }) {
        return api.carrygold_chat.get_chat_list(state.user_id, count);
    },
    CARRYGOLD_GET_CHAT_LIST_BY_USER({ state }, { user_id, count }) {
        return api.carrygold_chat.get_chat_list_by_user(state.user_id, user_id, count);
    },
    CARRYGOLD_GET_CHAT_REPORT_LIST({ state }, { user_id, count }) {
        return api.carrygold_chat.get_chat_report_list(state.user_id, user_id, count);
    },
    CARRYGOLD_GET_CHAT_USER_INFO({ state }, { user_id }) {
        return api.carrygold_chat.get_chat_user_info(state.user_id, user_id);
    },
    CARRYGOLD_BAN_CHAT_USER({ state }, { user_id, ban_hours }) {
        return api.carrygold_chat.ban_chat_user(state.user_id, user_id, ban_hours);
    },
    CARRYGOLD_UNBAN_CHAT_USER({ state }, { user_id }) {
        return api.carrygold_chat.unban_chat_user(state.user_id, user_id);
    },

    //////////////////////////[ GAME SETTING ]//////////////////////////
    // eslint-disable-next-line no-empty-pattern
    CARRYGOLD_GET_GAME_SETTING({ state }, { }) {
        return api.carrygold_setting.get_game_setting(state.user_id);
    },
    CARRYGOLD_SET_GAME_SETTING({ state }, { packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name }) {
        console.log("SET_GAME_SETTING :  " + packageName);
        console.log("SET_GAME_SETTING :  " + aos_ver);
        console.log("SET_GAME_SETTING :  " + ios_ver);
        console.log("SET_GAME_SETTING :  " + server_state_aos);
        console.log("SET_GAME_SETTING :  " + server_state_ios);
        console.log("SET_GAME_SETTING :  " + service_opt);
        return api.carrygold_setting.set_game_setting(state.user_id, packageName, aos_ver, ios_ver, server_state_aos, server_state_ios, service_opt, game_name);
    },
    CARRYGOLD_ADD_UPLOAD_TABLE_INFO({ state }, { packageName, version, user_id, file_path }) {
        return api.carrygold_setting.add_upload_table_info(state.user_id, packageName, version, user_id, file_path);
    },
    CARRYGOLD_GET_UPLOAD_TABLE_INFO({ state }, { packageName }) {
        return api.carrygold_setting.get_upload_table_info(state.user_id, packageName);
    },
    CARRYGOLD_USER_KICK({ state }, { packageName }) {
        return api.carrygold_setting.user_kick(state.user_id, packageName);
    },
    CARRYGOLD_DELETE_USER_ALL({ state }, { packageName }) {
        return api.carrygold_setting.delete_user_all(packageName);
    },
    CARRYGOLD_DELETE_USER({ state }, { packageName, user_id }) {
        return api.carrygold_setting.delete_user(state.user_id, packageName, user_id);
    },


    CARRYGOLD_GET_SWAP_COIN_LIST({ state }) {
        return api.carrygold.get_swap_coin_list(state.user_id);
    },
    CARRYGOLD_CREATE_SWAP_COIN_INFO({ state }, { coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type }) {
        return api.carrygold.create_swap_coin_info(state.user_id, coin_tag, thumb_img, coin_nm, product_price, snap_coin_price, tax_per, destination_tag, enable_state, type);
    },
    CARRYGOLD_EDIT_SWAP_COIN_INFO({ state }, { pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state }) {
        return api.carrygold.edit_swap_coin_info(state.user_id, pid, thumb_img, product_price, snap_coin_price, tax_per, destination_tag, enable_state);
    },
    CARRYGOLD_PM2_RESTART({ state }) {
        return api.carrygold.pm2_restart(state.user_id);
    },
    GET_CLIENT_LOG_LIST({ state }, { count, user_id }) {
        return api.carrygold.get_client_log_list(state.user_id, count, user_id);
    },
    CARRYGOLD_GET_COIN_ORDER_LIST({ state }, { count }) {
        return api.carrygold.get_coin_order_list(state.user_id, count);
    },
    CARRYGOLD_SEARCH_COIN_ORDER_LIST({ state }, { user_id }) {
        return api.carrygold.search_coin_order_list(state.user_id, user_id);
    },
    CARRYGOLD_EDIT_COIN_ORDER_STATE({ state }, { pid, process_state, comment }) {
        return api.carrygold.edit_coin_order_state(state.user_id, pid, process_state, comment);
    },

    CARRYGOLD_GET_CASH_ORDER_LIST({ state }, { count }) {
        return api.carrygold.get_cash_order_list(state.user_id, count);
    },
    CARRYGOLD_SEARCH_CASH_ORDER_LIST({ state }, { user_id }) {
        return api.carrygold.search_cash_order_list(state.user_id, user_id);
    },
    CARRYGOLD_EDIT_CASH_ORDER_STATE({ state }, { pid, process_state, comment }) {
        return api.carrygold.edit_cash_order_state(state.user_id, pid, process_state, comment);
    },

    CARRYGOLD_GET_GOLD_ORDER_LIST({ state }, { count }) {
        return api.carrygold.get_gold_order_list(state.user_id, count);
    },
    CARRYGOLD_SEARCH_GOLD_ORDER_LIST({ state }, { user_id }) {
        return api.carrygold.search_gold_order_list(state.user_id, user_id);
    },
    CARRYGOLD_EDIT_GOLD_ORDER_STATE({ state }, { pid, process_state, comment, delivery_company, tracking_no }) {
        return api.carrygold.edit_gold_order_state(state.user_id, pid, process_state, comment, delivery_company, tracking_no);
    },

    CARRYGOLD_GET_YOUTUBE_VIDEO_INFO({ state }) {
        return api.carrygold.get_youtube_video_info(state.user_id);
    },

    CARRYGOLD_REGIST_YOUTUBE_VIDEO_INFO({ state }, { yt_video_id, comment, user_id }) {
        return api.carrygold.regist_youtube_video_info(state.user_id, yt_video_id, comment, user_id);
    },

    CARRYGOLD_EDIT_YOUTUBE_VIDEO_INFO({ state }, { pid, comment, user_id, activate }) {
        return api.carrygold.edit_youtube_video_info(state.user_id, pid, comment, user_id, activate);
    },

    CARRYGOLD_GET_YOUTUBE_REPORT_INFO({ state }, { pid, process_state, comment }) {
        return api.carrygold.get_youtube_report_info(state.user_id, pid, process_state, comment);
    },

    CARRYGOLD_EDIT_YOUTUBE_REPORT_INFO({ state }, { pid, activate }) {
        return api.carrygold.edit_youtube_report_info(state.user_id, pid, activate);
    },
    //#endregion
    CARRYGOLD_GET_USER_BUY_PRODUCTS({ state }) {
        return api.carrygold_user_buy_products.get_user_buy_products();
    },
    // 개발 유틸리티
    CARRYGOLD_SEND_REALTIME_NOTIFICATION({ state }, { user_id, msg_tag, user_message }) {
        return api.carrygold_dev.send_realtime_notification(state.user_id, user_id, msg_tag, user_message);
    },
    CARRYGOLD_SEND_PUSH_TEST({ state }, { push_token, user_message, title, user_id }) {
        return api.carrygold_dev.send_push_test(state.user_id, push_token, user_message, title, user_id);
    },
    CARRYGOLD_OFFERWALL_RECEIVE_SNAPPLAY({ state }, { pub_user_nm, user_pnt }) {
        return api.carrygold_dev.offerwall_receive_snapplay(state.user_id, pub_user_nm, user_pnt);
    },
    CARRYGOLD_OFFERWALL_TEST({ state }, { provider, user_id, user_pnt, adv_id, base_domain }) {
        return api.carrygold_dev.offerwall_test(state.user_id, provider, user_id, user_pnt, adv_id, base_domain);
    },
    // [API 테스터] 유저 아이디로 푸시 발송
    CARRYGOLD_SEND_PUSH_BY_USERID({ state }, { user_id, title, message }) {
        return api.carrygold_dev.send_push_by_userid(state.user_id, user_id, title, message);
    },
    CARRYGOLD_GET_RECENT_ADV_IDS({ state }) {
        return api.carrygold_dev.get_recent_adv_ids(state.user_id);
    },
    CARRYGOLD_RECEIVE_SNAPPLAY_REVIEW_EVENT({ state }, { attr_id, actn_cd }) {
        return api.carrygold_dev.receive_snapplay_review_event(state.user_id, attr_id, actn_cd);
    },
    CARRYGOLD_DEV_GIVE_POINT({ state }, { user_id, amount, reason }) {
        return api.carrygold_dev.dev_give_point(state.user_id, user_id, amount, reason);
    },
    CARRYGOLD_DEV_ROULETTE_JOIN({ state }, { user_id, round_pid, bet_gold, bet_tag }) {
        return api.carrygold_dev.dev_roulette_join(state.user_id, user_id, round_pid, bet_gold, bet_tag);
    },
    CARRYGOLD_GET_DASHBOARD_DATA({ state }) {
        return api.carrygold.get_dashboard_data(state.user_id);
    },
    CARRYGOLD_GET_DAILY_SALES_STATISTICS({ state }) {
        return api.carrygold.get_daily_sales_statistics(state.user_id);
    },

    //////////////////////////[ 단타의 신 ]//////////////////////////
    // 고객사
    DANTA_GET_CLIENT_LIST({ state }) {
        return api.danta_client.get_client_list(state.user_id);
    },
    DANTA_CREATE_CLIENT({ state }, data) {
        return api.danta_client.create_client(state.user_id, data);
    },
    DANTA_UPDATE_CLIENT({ state }, data) {
        return api.danta_client.update_client(state.user_id, data);
    },
    DANTA_DELETE_CLIENT({ state }, { client_id }) {
        return api.danta_client.delete_client(state.user_id, client_id);
    },
    DANTA_GET_CLIENT_USER_LIST({ state }, { client_id }) {
        return api.danta_client.get_client_user_list(state.user_id, client_id);
    },
    DANTA_SAVE_CLIENT_USERS({ state }, { client_id, users }) {
        return api.danta_client.save_client_users(state.user_id, client_id, users);
    },
    DANTA_GET_CLIENT_CONTACT_LIST({ state }, { client_id }) {
        return api.danta_client.get_client_contact_list(state.user_id, client_id);
    },
    DANTA_SAVE_CLIENT_CONTACTS({ state }, { client_id, contacts }) {
        return api.danta_client.save_client_contacts(state.user_id, client_id, contacts);
    },
    // 매체
    DANTA_GET_MEDIA_LIST({ state }, { client_id }) {
        return api.danta_media.get_media_list(state.user_id, client_id);
    },
    DANTA_CREATE_MEDIA({ state }, data) {
        return api.danta_media.create_media(state.user_id, data);
    },
    DANTA_UPDATE_MEDIA({ state }, data) {
        return api.danta_media.update_media(state.user_id, data);
    },
    DANTA_DELETE_MEDIA({ state }, { media_id }) {
        return api.danta_media.delete_media(state.user_id, media_id);
    },
    // 유저
    DANTA_SEARCH_USER({ state }, filter) {
        return api.danta_user.search_user(state.user_id, filter);
    },
    DANTA_GET_USER_DETAIL({ state }, { client_id, app_key, user_id }) {
        return api.danta_user.get_user_detail(state.user_id, client_id, app_key, user_id);
    },
    DANTA_GET_USER_BY_UNIQUE_KEY({ state }, { unique_key }) {
        return api.danta_user.get_user_by_unique_key(state.user_id, unique_key);
    },
    DANTA_BAN_USER({ state }, { client_id, app_key, user_id, status }) {
        return api.danta_user.ban_user(state.user_id, client_id, app_key, user_id, status);
    },
    DANTA_GET_USER_COUNT({ state }, { client_id, app_key }) {
        return api.danta_user.get_user_count(state.user_id, client_id, app_key);
    },
    // 게임 템플릿
    DANTA_GET_GAME_TEMPLATE_LIST({ state }) {
        return api.danta_game_template.get_list(state.user_id);
    },
    DANTA_CREATE_GAME_TEMPLATE({ state }, data) {
        return api.danta_game_template.create(state.user_id, data);
    },
    DANTA_UPDATE_GAME_TEMPLATE({ state }, data) {
        return api.danta_game_template.update(state.user_id, data);
    },
    // 게임 회차
    DANTA_GET_GAME_LIST({ state }, { status, template_id, symbol, page, page_size }) {
        return api.danta_game.get_list(state.user_id, status, template_id, symbol, page, page_size);
    },
    DANTA_GET_GAME_DETAIL({ state }, { game_id }) {
        return api.danta_game.get_detail(state.user_id, game_id);
    },
    DANTA_CREATE_GAME({ state }, data) {
        return api.danta_game.create(state.user_id, data);
    },
    DANTA_UPDATE_GAME_STATUS({ state }, { game_id, status }) {
        return api.danta_game.update_status(state.user_id, game_id, status);
    },
    // 게임 메타/운영/margin 수정 — data: { game_id, title?, margin?, round_duration?, bet_cutoff?, schedule_type?, bet_amount?, ... }
    DANTA_UPDATE_GAME({ state }, data) {
        return api.danta_game.update(state.user_id, data);
    },
    // ── 선택지 그룹 (가격형/sports 자동화 공통) ──
    DANTA_GET_CHOICE_GROUPS({ state }, payload) {
        return api.danta_choice_group.get_list(state.user_id, payload || {});
    },
    DANTA_CREATE_CHOICE_GROUP({ state }, data) {
        return api.danta_choice_group.create(state.user_id, data);
    },
    // ── manual 운영 (퀴즈/정치/이벤트) ──
    DANTA_MANUAL_ROUND_CREATE({ state }, data) {
        return api.danta_manual_round.create(state.user_id, data);
    },
    DANTA_MANUAL_ROUND_CLOSE({ state }, { round_id }) {
        return api.danta_manual_round.close(state.user_id, round_id);
    },
    DANTA_MANUAL_ROUND_RESULT({ state }, payload) {
        return api.danta_manual_round.set_result(state.user_id, payload);
    },
    DANTA_MANUAL_ROUND_CANCEL({ state }, payload) {
        return api.danta_manual_round.cancel(state.user_id, payload);
    },
    DANTA_MANUAL_ROUNDS_LIST({ state }, payload) {
        return api.danta_manual_round.list(state.user_id, payload || {});
    },
    // ── DEV 전용 — 임의 결과 강제 정산 (테스트) ──
    DANTA_DEV_ROUND_INFO({ state }, { round_id }) {
        return api.danta_only_dev_api.get_round_info(state.user_id, round_id);
    },
    DANTA_DEV_FORCE_RESULT({ state }, payload) {
        return api.danta_only_dev_api.force_result(state.user_id, payload);
    },
    // 매체사 콜백 모니터링
    DANTA_CALLBACK_LIST({ state }, payload) {
        return api.danta_callback.get_list(state.user_id, payload || {});
    },
    DANTA_CALLBACK_STATS({ state }) {
        return api.danta_callback.get_stats(state.user_id);
    },
    DANTA_CALLBACK_CIRCUIT({ state }) {
        return api.danta_callback.get_circuit(state.user_id);
    },
    DANTA_CALLBACK_RETRY({ state }, { ids }) {
        return api.danta_callback.retry(state.user_id, ids);
    },
    // 게임 라운드
    DANTA_GET_GAME_ROUND_LIST({ state }, { game_id, status, page, page_size }) {
        return api.danta_game_round.get_list(state.user_id, game_id, status, page, page_size);
    },
    DANTA_GET_GAME_ROUND_DETAIL({ state }, { round_id }) {
        return api.danta_game_round.get_detail(state.user_id, round_id);
    },
    DANTA_GET_ROUND_BETS({ state }, params) {
        return api.danta_game_round.get_round_bets(state.user_id, params);
    },
    // 설정 - 노티 서버
    DANTA_GET_NOTI_SERVER_LIST({ state }) {
        return api.danta_setting.get_noti_server_list(state.user_id);
    },
    DANTA_CREATE_NOTI_SERVER({ state }, data) {
        return api.danta_setting.create_noti_server(state.user_id, data);
    },
    DANTA_UPDATE_NOTI_SERVER({ state }, data) {
        return api.danta_setting.update_noti_server(state.user_id, data);
    },
    DANTA_DELETE_NOTI_SERVER({ state }, { server_id }) {
        return api.danta_setting.delete_noti_server(state.user_id, server_id);
    },
    // 대시보드
    DANTA_GET_DASHBOARD({ state }) {
        return api.danta_dashboard.get_dashboard(state.user_id);
    },
    // Broadcast 서버 목록 + 접속자 수 (5초 폴링)
    DANTA_GET_BROADCAST_SERVERS({ state }) {
        return api.danta_dashboard.get_broadcast_servers(state.user_id);
    },
    // 디버그 테스트
    DANTA_RUN_BET_TEST({ state }, data) {
        return api.danta_debug.run_bet_test(state.user_id, data);
    },
    // 진행중 라운드 조회 (디버그 — 라운드 강제 무효 탭)
    DANTA_GET_CURRENT_ROUND({ state }, { game_id }) {
        return api.danta_debug.get_current_round(state.user_id, game_id);
    },
    // 라운드 강제 무효 (디버그)
    DANTA_CANCEL_ROUND({ state }, { round_id, reason }) {
        return api.danta_debug.cancel_round(state.user_id, round_id, reason);
    },
    // bet_orders 조회 (디버그 — filters: game_id/round_id/status/app_key/user_id/since/limit)
    DANTA_GET_BET_ORDERS({ state }, filters) {
        return api.danta_debug.get_bet_orders(state.user_id, filters);
    },
    // 특정 order_id 의 콜백 시도 이력
    DANTA_GET_BET_ORDER_ATTEMPTS({ state }, { order_id }) {
        return api.danta_debug.get_bet_order_attempts(state.user_id, order_id);
    },

    // ── 통계 / 정산 ──
    DANTA_STATS_TODAY_SUMMARY({ state }) {
        return api.danta_stats.today_summary(state.user_id);
    },
    DANTA_STATS_TODAY_BY_MEDIA({ state }, { limit } = {}) {
        return api.danta_stats.today_by_media(state.user_id, limit);
    },
    DANTA_STATS_TODAY_BY_GAME({ state }, { limit } = {}) {
        return api.danta_stats.today_by_game(state.user_id, limit);
    },
    DANTA_STATS_DAILY_MEDIA({ state }, filters) {
        return api.danta_stats.daily_media(state.user_id, filters);
    },
    DANTA_STATS_DAILY_GAMES({ state }, filters) {
        return api.danta_stats.daily_games(state.user_id, filters);
    },
    DANTA_STATS_MONTHLY_MEDIA({ state }, filters) {
        return api.danta_stats.monthly_media(state.user_id, filters);
    },
    DANTA_STATS_MONTHLY_GAMES({ state }, filters) {
        return api.danta_stats.monthly_games(state.user_id, filters);
    },
    DANTA_STATS_CRON_STATUS({ state }) {
        return api.danta_stats.cron_status(state.user_id);
    },
    DANTA_STATS_RUN_DAILY({ state }, { date } = {}) {
        return api.danta_stats.run_daily(state.user_id, date);
    },
    DANTA_STATS_RUN_MONTHLY({ state }, { ym } = {}) {
        return api.danta_stats.run_monthly(state.user_id, ym);
    },
    //////////////////////////[ 포인트공장 유저 상세 (금털기 복사) ]//////////////////////////
    PNTF_BAN_USER({ state }, { packageName, target_user, exp, exp_info, server_index }) {
        return api.pnt_factory_user_info.ban_user(state.user_id, packageName, target_user, exp, exp_info, server_index);
    },
    PNTF_UNBAN_USER({ state }, { target_user }) {
        return api.pnt_factory_user_info.unban_user(state.user_id, target_user);
    },
    PNTF_GET_USER_INFO({ state }, { target_user }) {
        return api.pnt_factory_user_info.get_user_info(state.user_id, target_user);
    },
    PNTF_SET_REVIEW_STATE_REWARD({ state }, { user_id }) {
        return api.pnt_factory_user_info.set_review_state_reward(state.user_id, user_id);
    },
    PNTF_SET_USER_INFO_DATA({ state }, { user_id, data }) {
        return api.pnt_factory_user_info.set_user_info_data(state.user_id, user_id, data);
    },
    PNTF_GET_CHAT_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.pnt_factory_user_info.get_chat_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    PNTF_CHANGE_USER_NICK_NAME({ state }, { user_id, nick }) {
        return api.pnt_factory_user_info.change_user_nick_name(state.user_id, user_id, nick);
    },
    PNTF_SET_USER_PHONE_NUMBER({ state }, { user_id, phone }) {
        return api.pnt_factory_user_info.set_user_phone_number(state.user_id, user_id, phone);
    },
    PNTF_RESET_USER_PHONE({ state }, { user_id }) {
        return api.pnt_factory_user_info.reset_user_phone(state.user_id, user_id);
    },
    PNTF_GET_USER_REFEREE_LIST({ state }, { user_id }) {
        return api.pnt_factory_user_info.get_user_referee_list(state.user_id, user_id);
    },
    PNTF_GET_USER_CPU_LIST({ state }, { user_id }) {
        return api.pnt_factory_user_info.get_user_cpu_list(state.user_id, user_id);
    },
    PNTF_GET_USER_CASHLOG_LIST({ state }, { user_id }) {
        return api.pnt_factory_user_info.get_user_cashlog_list(state.user_id, user_id);
    },
    PNTF_GET_USER_GEMLOG_LIST({ state }, { user_id, start_dt, end_dt }) {
        return api.pnt_factory_user_info.get_user_gemlog_list(state.user_id, user_id, start_dt, end_dt);
    },
    PNTF_REFUND_USER_CPU({ state }, { user_id, bonus_log_pid, refund_cash }) {
        return api.pnt_factory_user_info.refund_user_cpu(state.user_id, user_id, bonus_log_pid, refund_cash);
    },
    PNTF_REFUND_GEM_LOG({ state }, { gem_log_pid }) {
        return api.pnt_factory_user_info.refund_gem_log(state.user_id, gem_log_pid);
    },
    PNTF_SET_FRIEND_SHARE_PER({ state }, { user_id, friend_share_per }) {
        return api.pnt_factory_user_info.set_friend_share_per(state.user_id, user_id, friend_share_per);
    },

    //////////////////////////[ 포인트공장 개발 유틸리티 (금털기 복사, 룰렛 제외) ]//////////////////////////
    PNTF_SEND_REALTIME_NOTIFICATION({ state }, { user_id, msg_tag, user_message }) {
        return api.pnt_factory_dev.send_realtime_notification(state.user_id, user_id, msg_tag, user_message);
    },
    PNTF_SEND_PUSH_TEST({ state }, { push_token, user_message, title, user_id }) {
        return api.pnt_factory_dev.send_push_test(state.user_id, push_token, user_message, title, user_id);
    },
    PNTF_OFFERWALL_RECEIVE_SNAPPLAY({ state }, { pub_user_nm, user_pnt }) {
        return api.pnt_factory_dev.offerwall_receive_snapplay(state.user_id, pub_user_nm, user_pnt);
    },
    PNTF_OFFERWALL_TEST({ state }, { provider, user_id, user_pnt, adv_id, base_domain }) {
        return api.pnt_factory_dev.offerwall_test(state.user_id, provider, user_id, user_pnt, adv_id, base_domain);
    },
    PNTF_GET_RECENT_ADV_IDS({ state }) {
        return api.pnt_factory_dev.get_recent_adv_ids(state.user_id);
    },
    PNTF_RECEIVE_SNAPPLAY_REVIEW_EVENT({ state }, { attr_id, actn_cd }) {
        return api.pnt_factory_dev.receive_snapplay_review_event(state.user_id, attr_id, actn_cd);
    },
    PNTF_DEV_GIVE_POINT({ state }, { user_id, amount, reason }) {
        return api.pnt_factory_dev.dev_give_point(state.user_id, user_id, amount, reason);
    },
    //////////////////////////[ 돈만농 유저 상세 (금털기 복사) ]//////////////////////////
    MANDOORA_BAN_USER({ state }, { packageName, target_user, exp, exp_info, server_index }) {
        return api.mandoora_user_info.ban_user(state.user_id, packageName, target_user, exp, exp_info, server_index);
    },
    MANDOORA_UNBAN_USER({ state }, { target_user }) {
        return api.mandoora_user_info.unban_user(state.user_id, target_user);
    },
    MANDOORA_GET_USER_INFO({ state }, { target_user }) {
        return api.mandoora_user_info.get_user_info(state.user_id, target_user);
    },
    MANDOORA_SET_REVIEW_STATE_REWARD({ state }, { user_id }) {
        return api.mandoora_user_info.set_review_state_reward(state.user_id, user_id);
    },
    MANDOORA_SET_USER_INFO_DATA({ state }, { user_id, data }) {
        return api.mandoora_user_info.set_user_info_data(state.user_id, user_id, data);
    },
    MANDOORA_GET_CHAT_LOG_DATA({ state }, { packageName, user_id, start_date, end_date, server_index }) {
        return api.mandoora_user_info.get_chat_log_data(state.user_id, packageName, user_id, start_date, end_date, server_index);
    },
    MANDOORA_CHANGE_USER_NICK_NAME({ state }, { user_id, nick }) {
        return api.mandoora_user_info.change_user_nick_name(state.user_id, user_id, nick);
    },
    MANDOORA_SET_USER_PHONE_NUMBER({ state }, { user_id, phone }) {
        return api.mandoora_user_info.set_user_phone_number(state.user_id, user_id, phone);
    },
    MANDOORA_RESET_USER_PHONE({ state }, { user_id }) {
        return api.mandoora_user_info.reset_user_phone(state.user_id, user_id);
    },
    MANDOORA_GET_USER_REFEREE_LIST({ state }, { user_id }) {
        return api.mandoora_user_info.get_user_referee_list(state.user_id, user_id);
    },
    MANDOORA_GET_USER_CPU_LIST({ state }, { user_id }) {
        return api.mandoora_user_info.get_user_cpu_list(state.user_id, user_id);
    },
    MANDOORA_GET_USER_CASHLOG_LIST({ state }, { user_id }) {
        return api.mandoora_user_info.get_user_cashlog_list(state.user_id, user_id);
    },
    MANDOORA_GET_USER_GEMLOG_LIST({ state }, { user_id, start_dt, end_dt }) {
        return api.mandoora_user_info.get_user_gemlog_list(state.user_id, user_id, start_dt, end_dt);
    },
    MANDOORA_REFUND_USER_CPU({ state }, { user_id, bonus_log_pid, refund_cash }) {
        return api.mandoora_user_info.refund_user_cpu(state.user_id, user_id, bonus_log_pid, refund_cash);
    },
    MANDOORA_REFUND_GEM_LOG({ state }, { gem_log_pid }) {
        return api.mandoora_user_info.refund_gem_log(state.user_id, gem_log_pid);
    },
    MANDOORA_SET_FRIEND_SHARE_PER({ state }, { user_id, friend_share_per }) {
        return api.mandoora_user_info.set_friend_share_per(state.user_id, user_id, friend_share_per);
    },

    //////////////////////////[ 돈만농 개발 유틸리티 (금털기 복사, 룰렛 제외) ]//////////////////////////
    MANDOORA_SEND_REALTIME_NOTIFICATION({ state }, { user_id, msg_tag, user_message }) {
        return api.mandoora_dev.send_realtime_notification(state.user_id, user_id, msg_tag, user_message);
    },
    MANDOORA_SEND_PUSH_TEST({ state }, { push_token, user_message, title, user_id }) {
        return api.mandoora_dev.send_push_test(state.user_id, push_token, user_message, title, user_id);
    },
    MANDOORA_OFFERWALL_RECEIVE_SNAPPLAY({ state }, { pub_user_nm, user_pnt }) {
        return api.mandoora_dev.offerwall_receive_snapplay(state.user_id, pub_user_nm, user_pnt);
    },
    MANDOORA_OFFERWALL_TEST({ state }, { provider, user_id, user_pnt, adv_id, base_domain }) {
        return api.mandoora_dev.offerwall_test(state.user_id, provider, user_id, user_pnt, adv_id, base_domain);
    },
    MANDOORA_GET_RECENT_ADV_IDS({ state }) {
        return api.mandoora_dev.get_recent_adv_ids(state.user_id);
    },
    MANDOORA_RECEIVE_SNAPPLAY_REVIEW_EVENT({ state }, { attr_id, actn_cd }) {
        return api.mandoora_dev.receive_snapplay_review_event(state.user_id, attr_id, actn_cd);
    },
    MANDOORA_DEV_GIVE_POINT({ state }, { user_id, amount, reason }) {
        return api.mandoora_dev.dev_give_point(state.user_id, user_id, amount, reason);
    },

}

export default actions;